import { Injectable } from '@angular/core';
import { Parameter } from '../app/admin-pages/parameters/core/parameter';
import { PscHttpService } from './psc-http.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  baseEndpoint = 'config/';

  constructor(
    private httpService: PscHttpService,
  ) {
  }
  
  getPriceParams() {
    return this.httpService.get(`${ this.baseEndpoint }/packagePrices`).pipe(
      map(priceParams => priceParams as Parameter[]),
    );
  }

  getAllParameters() {
    return this.httpService.get(`${ this.baseEndpoint }`).pipe(
      map(parameters => parameters as Parameter[]),
    );
  }

  getParameter(configId: string): Observable<Parameter> {
    return this.httpService.get(`${ this.baseEndpoint }${ configId }`);
  }

  addParameter(parameter: Parameter): Observable<Parameter> {
    return this.httpService.post(`${ this.baseEndpoint }`, parameter);
  }

  updateParameter(parameter: Parameter): Observable<Parameter> {
    return this.httpService.put(`${ this.baseEndpoint }`, parameter);
  }

  deleteParameter(configId: string) {
    return this.httpService.delete(`${ this.baseEndpoint }${ configId }`);
  }
}
